export default __webpack_public_path__ + "img/producer-left.asset.dc937636.jpeg";